/* eslint-disable block-scoped-var */
/* eslint-disable eqeqeq */
/* eslint-disable no-sequences */
/* eslint-disable no-loop-func */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */
/* eslint-disable prefer-destructuring */
/* eslint-disable prefer-spread */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-param-reassign */
/* eslint-disable no-multi-assign */
/* eslint-disable func-names */
/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
// @ts-nocheck
import { getUserType } from '@schemeserve/global-utils';
import smartlookClient from 'smartlook-client';

export const initFathom = (): void => {
  const script = document.createElement('script');
  script.src = 'https://nine-green.schemeserve.com/script.js';
  script.defer = true;
  script.setAttribute('data-site', 'ZQQVKPXI');
  document.body.appendChild(script);
};

type initDelightedProps = {
  user: {
    Username: string;
    UserId: string;
    accessGroup: string;
    AccountId: string;
    MasterAccountId: string;
    siteUrl: string;
  };
  email: string;
  accountId: string;
};

export const initDelighted = ({
  user,
  email,
  accountId,
}: initDelightedProps): void => {
  const {
    Username: username,
    UserId: userId,
    accessGroup,
    MasterAccountId: masterAccountId,
    siteUrl,
  } = user;
  !(function delightedInit(e, t, r, n) {
    if (!e[n]) {
      for (
        var a = (e[n] = []),
          i = [
            'survey',
            'reset',
            'config',
            'init',
            'set',
            'get',
            'event',
            'identify',
            'track',
            'page',
            'screen',
            'group',
            'alias',
          ],
          s = 0;
        s < i.length;
        s += 1
      ) {
        const c = i[s];
        a[c] =
          a[c] ||
          (function (e) {
            return function () {
              const t = Array.prototype.slice.call(arguments);
              a.push([e, t]);
            };
          })(c);
      }
      a.SNIPPET_VERSION = '1.0.1';
      const o = t.createElement('script');
      o.type = 'text/javascript';
      o.async = !0;
      o.src = `https://d2yyd1h5u9mauk.cloudfront.net/integrations/web/v1/library/${r}/${n}.js`;
      const l = t.getElementsByTagName('script')[0];
      l.parentNode.insertBefore(o, l);
    }
  })(window, document, 'NI9TKizBTyCB3laG', 'delighted');

  delighted.survey({
    // createdAt: '2016-01-01T12:00:00Z', // time subscribed (optional)
    email,
    name: username,
    properties: {
      userId,
      accessGroup,
      masterAccountId,
      accountId,
      siteUrl,
    },
  });
};

export const initSmartlook = (): void => {
  const userType = getUserType(window.User.AccessGroup);
  if (window.isLoggedIn && !userType.isClient) {
    smartlookClient.init('5dd97c9b4b57e055ab299a42114820e43159ac74', {
      region: 'eu',
      version: 'nextgen',
    });
  }
};

export const initGoogleAnalyticsV3 = (analyticsId: string): void => {
  (function (i, s, o, g, r, a, m) {
    i.GoogleAnalyticsObject = r;
    (i[r] =
      i[r] ||
      function () {
        (i[r].q = i[r].q || []).push(arguments);
      }),
      (i[r].l = 1 * new Date());
    (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(
    window,
    document,
    'script',
    'https://www.google-analytics.com/analytics.js',
    'ga',
  );
  ga('create', analyticsId, 'auto');
  ga('set', 'forceSSL', true);
  ga('send', 'pageview');
};

export const initGoogleAnalyticsV4 = (googleAnalyticsId: string): void => {
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId}`;
  script.async = true;
  document.body.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag('js', new Date());

  gtag('config', googleAnalyticsId);
};

export const initGoogleTagManager = (googleTagManagerId: string): void => {
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l != 'dataLayer' ? `&l=${l}` : '';
    j.async = true;
    j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', googleTagManagerId);

  //   <!-- Google Tag Manager (noscript) -->
  // <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PSR46T5"
  // height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
  // <!-- End Google Tag Manager (noscript) -->
};

export const initFacebookPixel = (facebookPixelId: string): void => {
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  );
  fbq('init', facebookPixelId);
  fbq('track', 'PageView');
  // <noscript><img height="1" width="1" style="display:none"
  //       src="https://www.facebook.com/tr?id=440162579739199&ev=PageView&noscript=1"
  //     /></noscript>
};

export const initLinkedinPixel = (linkedinId: string): void => {
  const _linkedin_partner_id = linkedinId;
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push(_linkedin_partner_id);
  (function (l) {
    if (!l) {
      window.lintrk = function (a, b) {
        window.lintrk.q.push([a, b]);
      };
      window.lintrk.q = [];
    }
    const s = document.getElementsByTagName('script')[0];
    const b = document.createElement('script');
    b.type = 'text/javascript';
    b.async = true;
    b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
    s.parentNode.insertBefore(b, s);
  })(window.lintrk);

  //  <noscript>  <img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=2979321&fmt=gif" />  </noscript>
};

export const initHubspot = (hubspotId: string): void => {
  const script = document.createElement('script');
  script.src = `//js.hs-scripts.com/${hubspotId}.js`;
  script.async = true;
  script.defer = true;
  script.id = 'hs-script-loader';
  script.type = 'text/javascript';
  document.body.appendChild(script);
};
